import React from "react";
import ReactDOM from "react-dom";


const MyAccountIcon = () =>{
    return(
        <>
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 20" fill="none">
<path d="M7.1465 8.96401C7.05483 8.95485 6.94483 8.95485 6.844 8.96401C5.79185 8.92829 4.79492 8.48445 4.06432 7.72648C3.33373 6.96851 2.92684 5.95593 2.92983 4.90318C2.92983 2.65735 4.74483 0.833181 6.99983 0.833181C7.53371 0.823551 8.06426 0.91917 8.56118 1.11458C9.05811 1.30999 9.51167 1.60136 9.89599 1.97206C10.2803 2.34276 10.5879 2.78552 10.8011 3.27508C11.0143 3.76463 11.129 4.29139 11.1386 4.82526C11.1482 5.35914 11.0526 5.88969 10.8572 6.38661C10.6618 6.88354 10.3704 7.33711 9.9997 7.72143C9.629 8.10574 9.18624 8.41329 8.69668 8.62649C8.20713 8.83969 7.68038 8.95438 7.1465 8.96401ZM2.56316 12.3465C0.344831 13.8315 0.344831 16.2515 2.56316 17.7273C5.084 19.414 9.21816 19.414 11.739 17.7273C13.9573 16.2423 13.9573 13.8223 11.739 12.3465C9.22733 10.669 5.09316 10.669 2.56316 12.3465Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
        </>
    )
}

export default MyAccountIcon;